module.exports = __webpack_public_path__ + "static/media/鰻魚飯.cdc790d6.jpg";